module.exports = __webpack_public_path__ + "static/media/project-image-1.d69dbcf7.jpg";